export default function Stepper({ label, value, setValue, min = 0, max = 20, testid }) {
  return (
    <div className="flex items-center justify-between py-1.5">
      <span className="text-sm">{label}</span>
      <div className="inline-flex items-center gap-3">
        <button type="button" className="w-7 h-7 rounded-full border border-[#E2DACF] hover:border-[#1E3A2B]" data-testid={`${testid}-dec`} onClick={() => setValue(Math.max(min, value - 1))}>−</button>
        <span className="w-5 text-center" data-testid={`${testid}-val`}>{value}</span>
        <button type="button" className="w-7 h-7 rounded-full border border-[#E2DACF] hover:border-[#1E3A2B]" data-testid={`${testid}-inc`} onClick={() => setValue(Math.min(max, value + 1))}>+</button>
      </div>
    </div>
  );
}
